import React from 'react';
import { FadeInUp } from './FadeInUp';
export function Hero() {
  const scrollToForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-deep-blue text-white pt-20 pb-24 lg:pt-32 lg:pb-32 overflow-hidden" data-id="element-21">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-22">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-23">
          <div className="max-w-2xl" data-id="element-24">
            <FadeInUp data-id="element-25">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-tight mb-6" data-id="element-26">
                Protege a tu familia y haz crecer tus ahorros con un IUL
              </h1>
            </FadeInUp>

            <FadeInUp delay={0.1} data-id="element-27">
              <p className="text-lg md:text-xl text-blue-100 mb-8 leading-relaxed" data-id="element-28">
                Un plan inteligente con crecimiento anual y protección ante lo
                inesperado
              </p>
            </FadeInUp>

            <FadeInUp delay={0.2} data-id="element-29">
              <a href="#lead-form" onClick={scrollToForm} className="inline-block bg-vitality-green hover:bg-vitality-green-hover text-white font-semibold text-lg px-8 py-4 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-30">
                Solicitar mi asesoría gratuita
              </a>
            </FadeInUp>
          </div>

          <FadeInUp delay={0.3} className="relative" data-id="element-31">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3] lg:aspect-auto lg:h-[500px]" data-id="element-32">
              <img src="https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800" alt="Familia hispana feliz y protegida" className="absolute inset-0 w-full h-full object-cover" data-id="element-33" />
              <div className="absolute inset-0 bg-gradient-to-t from-deep-blue/40 to-transparent" data-id="element-34"></div>
            </div>
          </FadeInUp>
        </div>
      </div>
    </section>;
}